import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { RegisterInviteCodeComponent } from './components/register-invite-code/register-invite-code.component';
import { SsoAuthComponent } from './pages/sso-auth/sso-auth.component';

// The redirect-portal binary is hosted on two subdomains. On ssoauth.* it
// must serve ONLY the SSO launch page — none of the redirect/invite-code
// flows should be reachable from that host.
const isSsoAuthHost =
  typeof window !== 'undefined' &&
  /^ssoauth(\.|-)/i.test(window.location.hostname);

export const routes: Routes = isSsoAuthHost
  ? [
      { path: '**', component: SsoAuthComponent },
    ]
  : [
      {
        path: '',
        component: LayoutComponent,
        children: [
          { path: 'register/invite-code', component: RegisterInviteCodeComponent },
          { path: '**', component: RedirectComponent },
        ],
      },
    ];
